/* eslint-disable react/prop-types */
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { ProblemStage } from '../common/page-info';
import { TagScenario } from '../common-components/tag-scenario';
import { getImageUrlFromScenario } from '../common/helpers';
import { FixedOptionData } from '../page-data/fixed-option-data';
import { FixedOptionsComp } from '../common-components/fixed-options';
import { PageComp } from './page-comp-props';
import { noOp } from '../utils/utils';

const FixedOptionComp: PageComp = (props) => {
  const { isTeacherView, stage, onChange = noOp, onReviewed } = props;
  const pageData = props.pageData as FixedOptionData;

  const { options, scenario, answer, reason } = pageData;

  const isReview = stage === ProblemStage.ShowResult;

  const generateContent = () => {
    return (
      <>
        <ReactMarkdown>
          {scenario?.content?.markdown || scenario?.content.text || ''}
        </ReactMarkdown>
      </>
    );
  };
  const imgUrl: string | undefined = getImageUrlFromScenario(scenario);
  const background: string | undefined = scenario?.metadata.patient.background;
  const content: string | JSX.Element = generateContent();

  return (
    <div>
      <TagScenario
        imgUrl={imgUrl}
        background={background}
        content={content}
        description={pageData.descriptionElement}
      />
      <FixedOptionsComp
        isTeacherView={!!isTeacherView}
        options={options}
        pageData={pageData}
        answer={answer}
        reason={reason}
        isReview={isReview}
        onChange={onChange}
        onReviewed={onReviewed}
      />
    </div>
  );
};
export default FixedOptionComp;
